module.exports = __webpack_public_path__ + "static/media/barbie.9a832656.png";